import React from 'react'
import { css, keyframes } from 'emotion'
import { Spacer, Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const animateOut = keyframes`
   0% {
      opacity: 1;
   }

   80% {
      opacity: 1;
   }

   100% {
      opacity: 0;
   }
`

// =======================================================
// Component
// =======================================================

const ActivityMessageListItem = ({
   action,
   actor,
   borderStyle,
   dateAdded,
   initiative,
   showNewMessageAnchor,
   target,
   textColor
}) => (
   <View
      float="left"
      width="100%"
      borderTop={borderStyle}>
      <View
         display="flex"
         padding="15px 0px[a-b] 15px 10px[c-f]">
         <View
            display="flex"
            alignItems="center"
            justifyContent="center"
            width="30px"
            height="30px"
            borderRadius="50%"
            backgroundColor="#ddd"
            marginRight="20px">
            <Text size="1" color="000" uppercase>
               <span role="img" aria-labelledby="activity">🉑</span>
            </Text>
         </View>
         <View flex="1 1 auto" maxWidth="calc(100% - 50px)">
            <View
               display="flex"
               justifyContent="space-between">
               <View
                  display="block[a-b] flex[c-f]"
                  alignItems="center">
                  <Text size="1.5" color={textColor}>
                     {dateAdded}
                  </Text>
               </View>
            </View>
            <View display="block" width="100%" maxWidth="700px" paddingTop="2px" opacity="0.7">
               <Spacer size="1" />
               <Text size="2" lineHeight="150%" color={textColor}>
                  <Link to={`/profile/${actor.id}`} style={{ color: textColor, textDecoration: 'underline' }}>
                     {actor.fullName}
                  </Link>
                  {action === 'initiativeCreate' && ` has created the ${initiative.class} `}
                  {action.startsWith('note') && (
                     <>
                        {` has ${action.endsWith('Create') ? 'created' : 'updated'} the note `}
                        <a
                           href="https://notes.mother.co"
                           target="_blank"
                           style={{ color: textColor, textDecoration: 'underline' }}
                           rel="noopener noreferrer">
                           {target?.title}
                        </a>
                        {' '}
                     </>
                  )}
                  {initiative && (
                     <>
                        {!action.startsWith('initiative') && 'in '}
                        <Link to={`/apps/${initiative.class}/${initiative.slug}`} style={{ color: textColor, textDecoration: 'underline' }}>{initiative.name}</Link>
                     </>
                  )}
               </Text>
            </View>
         </View>
      </View>
      {showNewMessageAnchor && (
         <View
            className={css`
               opacity: 0;
               animation: ${animateOut} 10s ease-out;
            `}
            position="relative"
            top="1px"
            borderTop="1px solid #3893f2">
            <View
               display="flex"
               alignItems="center"
               height="16px"
               position="absolute"
               top="-8px"
               padding="0px 10px"
               borderRadius="2px"
               backgroundColor="#3893f2">
               <Text size="0.8" weight="medium" transform="uppercase" color="#fff">
                  New
               </Text>
            </View>
         </View>
      )}
   </View>
)

ActivityMessageListItem.propTypes = {
   action: PropTypes.string.isRequired,
   actor: PropTypes.object.isRequired,
   borderStyle: PropTypes.string,
   dateAdded: PropTypes.string.isRequired,
   initiative: PropTypes.object.isRequired,
   showNewMessageAnchor: PropTypes.bool,
   target: PropTypes.object,
   textColor: PropTypes.string
}

ActivityMessageListItem.defaultProps = {
   borderStyle: '1px solid #e5e5e5',
   showNewMessageAnchor: false,
   target: undefined,
   textColor: '#222'
}

export default ActivityMessageListItem
